// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xoV4","comment":"styles_comment__2wR62"};